<template>
  <div class="polls-wrapper">
    <div class="button-wrap">
      <button class="button-round" @click="openAddPage">Add new step</button>
      <div class="inner-wrap">
        <button class="button-round save" @click="save">Save</button>
        <button class="button-round cancel" @click="cancel">Cancel</button>
      </div>
    </div>
    <div class="list-of-questions">
      <div
        class="questions-page"
        v-for="(page, indexPage) in pollQuestions"
        :key="indexPage"
      >
        <div class="page-title">
          <div class="move">
            <button
              @click="swapPages(indexPage, indexPage - 1)"
              v-if="indexPage >= 1 && pollQuestions.length > 1"
            >
              <span class="material-icons"> expand_less </span>
            </button>
            <button
              @click="swapPages(indexPage, indexPage + 1)"
              v-if="
                indexPage < pollQuestions.length - 1 && pollQuestions.length > 1
              "
            >
              <span class="material-icons"> expand_more </span>
            </button>
            <span>Step: {{ page.title }}</span>
          </div>
          <div class="page-buttons-wrap">
            <button class="button-round" @click="editExistingPage(page)">
              Edit page
            </button>
            <button class="button-round delete" @click="deletePage(indexPage)">
              Delete page
            </button>
          </div>
        </div>

        <div
          class="single-question"
          v-for="question in page.data"
          :key="question.pqt_id"
        >
          <div class="content-wrap">
            <span class="type">{{ question.type }}:</span>
            <span class="title" v-if="question.text && question.text !== ' '" v-html="question.text"></span
            >
            <span class="title" v-else>No question text provided.</span>

            <div
              class="select"
              v-if="
                question.type === 'select' ||
                question.type === 'checkbox' ||
                question.type === 'radio' ||
                question.type === 'badge'
              "
            >
              <select>
                <option
                  v-for="(option, i) in question.answers.map((el) => {
                    return el.text;
                  })"
                  :key="i"
                >
                  {{ option }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <add-page
        v-if="isNewPageOpen"
        :page="page"
        @save="updateFromEdit"
        @close="closeAddPage"
      />
    </transition>
  </div>
</template>

<script>
import api from "@/api";
import addPage from "./AddPollQuestions";
export default {
  components: {
    // vSelect
    addPage,
  },
  data() {
    return {
      isNewPageOpen: false,
      pollQuestions: [],
      originalQuestions: [],
      page: null,
      points: 0,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      let pls_id = this.$route.params.id;
      this.startLoading();
      try {
        const res = await api.getSinglePoll({ pls_id: pls_id });
        console.log(res.data.data);
        this.pollQuestions = res.data.data;
        this.originalQuestions = res.data.data;
      } catch (error) {
        this.handleError(error);
      } finally {
        this.stopLoading();
      }
    },
    getBlankPage(page) {
      let generateUniquePPG = () => {
        let ppgId = Math.round(Math.random() * 100000);
        for (const page of this.pollQuestions) {
          if (page.ppg_id === ppgId) {
            ppgId = generateUniquePPG();
          }
        }
        return ppgId;
      };
      let newPage = {
        title: page.title ? page.title : "",
        data: page.data ? page.data : [],
        ppg_id: generateUniquePPG(),
      };
      return newPage;
    },
    updateFromEdit(page) {
      this.points = page.pls_points;
      let isNewPage = true;
      for (let i = 0; i < this.pollQuestions.length; i++) {
        const onePage = this.pollQuestions[i];
        if (onePage.ppg_id === page.ppg_id) {
          this.pollQuestions[i] = page;
          isNewPage = false;
        }
      }
      if (isNewPage) {
        let newPage = this.getBlankPage(page);
        this.pollQuestions.push(newPage);
      }
      this.closeAddPage();
    },
    deletePage(index) {
      let deletePageLogic = () => {
        let ret = this.pollQuestions.splice(index, 1);
        console.log(ret);
      };
      let obj = {
        okButton: "Delete",
        title: "Are you sure you want to delete this page?",
        okCallback: deletePageLogic,
      };
      this.EventBus.$emit("confirm", obj);
    },
    swapPages(i, j) {
      let arr = JSON.parse(JSON.stringify(this.pollQuestions));
      let t = arr[i];
      arr[i] = arr[j];
      arr[j] = t;
      this.pollQuestions = arr;
    },
    transformForApi() {
      let copyOfPoll = JSON.parse(JSON.stringify(this.pollQuestions));
      for (let i = 0; i < copyOfPoll.length; i++) {
        let element = copyOfPoll[i];
        delete element.ppg_id;
        element.index = i;
        for (let j = 0; j < element.data.length; j++) {
          let dataEl = element.data[j];
          delete dataEl.pqt_id;
          delete dataEl.temp;
          dataEl.index = j;
          if (
            dataEl.type === "badge" ||
            dataEl.type === "checkbox" ||
            dataEl.type === "select" ||
            dataEl.type === "radio"
          ) {
            delete dataEl.options;
            for (let z = 0; z < dataEl.answers.length; z++) {
              const ansEl = dataEl.answers[z];
              delete ansEl.pqa_id;
              delete ansEl.tempCID;
            }
          }
        }
      }
      let obj = {
        data: copyOfPoll,
      };
      console.log(obj);
      return obj;
    },
    async save() {
      let obj = this.transformForApi();
      console.log(JSON.stringify(obj), "ovo");
      console.log(obj);
      const pls_id = parseInt(this.$route.params.id);
      try {
        this.startLoading();
        await api.updatePollQuestions(obj, pls_id);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.stopLoading();
      }
    },
    cancel() {
      let cancelLogic = () => {
        this.pollQuestions = JSON.parse(JSON.stringify(this.originalQuestions));
        this.$router.push("/admin/polls");
      };
      let obj = {
        title: "You will lose all changes you have made on this questionnaire?",
        okCallback: cancelLogic,
      };
      this.EventBus.$emit("confirm", obj);
    },
    openAddPage() {
      this.isNewPageOpen = true;
    },
    editExistingPage(page) {
      this.page = page;
      this.openAddPage();
    },
    closeAddPage() {
      this.page = null;
      this.isNewPageOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.polls-wrapper {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  // background: aqua;
  overflow-y: auto;
  padding: 20px;
  .list-of-questions {
    margin-top: 15px;
    width: 100%;
    .questions-page {
      margin-top: 30px;
      .page-title {
        padding: 10px;
        margin: 0 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .move {
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }
        .page-buttons-wrap {
          button {
            margin: 0 5px;
            &.delete {
              background: #b88e8e;
            }
          }
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
      .single-question {
        padding: 10px 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .content-wrap {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .type {
            margin: 0 10px;
            min-width: 120px;
          }
          .title {
            margin: 0 10px;
          }
          .select {
            min-width: 170px;
          }
        }
      }
    }
  }
  .button-wrap {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    // margin-top: 50px;
    button {
      margin: 0 5px;
      width: 150px;
    }
    .cancel {
      background: rgb(184, 142, 142);
    }
    .inner-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.2s ease-out;
  }
}
</style>